import React from 'react';
import ReportAdminDetail from './reportAdminDetail.jsx';

const Index = () => {

	return(

		<ReportAdminDetail />

	)

}

export default Index;